import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faUserMagnifyingGlass';

import { Button, ButtonType } from '../../../../Button';

type Props = {
  header: string;
  content: string,
  handlePostAJob(): void;
}

export const BestMatchNullState = (props: Props): JSX.Element => {
  const { t } = useTranslation();
  const { header, content, handlePostAJob } = props;

  return (
    <div className='h-fit w-52 rounded-2xl border-2'>
      <div className='m-3'>
        <FontAwesomeIcon icon={faUserMagnifyingGlass} className='w-8 h-8' />
        <span className='block font-bold mt-2'>{header}</span>
        <span className='block mt-2'>{content}</span>
        <Button
          buttonType={ButtonType.primary}
          className='w-fit mt-3'
          onClick={handlePostAJob}
        >
          {t('dashboard.widgets.myJobPosts.postAJob')}
        </Button>
      </div>
    </div>
  );
};
